import React from "react";
import IntlMessages from "../../../utils/messages";
import Button from "../../Tailwind/Button";
import LinkButton from "../../Tailwind/LinkButton";

interface Props {
  visible: boolean;
  isSubmitting: boolean;
  onCancel?: (e) => void;
}

const FormSavePanel = (props: Props): JSX.Element => {
  const { visible, isSubmitting, onCancel } = props;

  return (
    <div className="bg-gray-900 opacity-90 shadow sm:rounded-lg fixed transform -translate-x-1/2 left-1/2 bottom-40 z-50">
      {visible && (
        <div className="px-4 py-5 sm:p-5">
          <div className="sm:flex sm:items-center sm:justify-between">
            <div className="max-w-xl leading-5 text-white">
              <p className="text-14px">
                <IntlMessages id="general.panel.save" />
              </p>
            </div>

            <div className="mx-6">
              <Button
                item={null}
                id="btn-save-panel"
                name="btn-save-panel"
                type="submit"
                disabled={isSubmitting}
              >
                <IntlMessages id="general.save" />
              </Button>
            </div>

            <LinkButton
              id="link-cancel-panel"
              name="link-cancel-panel"
              label="general.cancel"
              onClick={onCancel}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default FormSavePanel;
